import React from "react";
import {Col, Row} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import {getUser} from "../../utils/StorageUtil";
import queryString from 'query-string';
import SearchInput from "../../components/input/SearchInput";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";
import UserDeviceTable from "../../components/UserDeviceTable";

class UserDevicePage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      inputSearch: queryString.parse(this.props.query).search ? queryString.parse(this.props.query).search : "",
      user : getUser(),
      page: queryString.parse(props.query).page ? queryString.parse(props.query).page : 1,
      totalPage: 0,
      totalElement: 0,
      pageElement: 0,
      sortOption:{}
    }
  }

  componentDidMount() {
    super.componentDidMount();
      if(this.props?.navBar?.current){
          this.props.navBar.current.updateNavBarItems([UserDevicePage.PAGE_CONF])
      }

      this.closePreLoader()
  }

  componentWillReceiveProps(props, nextContext) {
    if (props != this.props) {
      let page = queryString.parse(props.query).page ? queryString.parse(props.query).page : 1
      let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
      let inputSearch = queryString.parse(props.query).search ? queryString.parse(props.query).search : ""
      this.setState({
        page: page,
        key: key,
        inputSearch: inputSearch
      })
    }
  }




  render() {
    let {sortOption} = this.state
    return (
        <>
          <div className="table-settings ms-md-3 me-md-3">
            <Row className="align-items-center">
                <Col xs={4} sm={4} md={2} lg={1} xl={1} className="ps-md-0 text-left mb-2">
                    <TableSortOption
                        sortOptions={
                            [
                                SortOption.init(label.Oldest,"ja.created",true),
                                SortOption.init(label.Latest,"ja.created",false)
                            ]
                        }
                        sortOption={sortOption}
                        placeholder={label.SortBy}
                        onSelect={(sortOption) => {
                            this.setState({sortOption},() => {
                                // this.fetchUsers()
                            })
                        }}
                        onReset={() => {
                            this.setState({sortOption:{}},() => {
                                // this.fetchUsers()
                            })
                        }}/>
                </Col>
                <Col xs={12} sm={8} md={6} lg={4} xl={4} className="mb-2">
                    <SearchInput
                        onEnter={(search) => {
                            this.setState({search}, () => {
                                // this.fetchUsers()
                            })
                        }} onEmpty={() => {
                        this.setState({search:""},() => {
                            // this.fetchUsers()
                        })
                    }}/>
                </Col>
            </Row>
          </div>
          <UserDeviceTable {...this.props} showProcessing={this.props.showProcessing} closeProcessing={this.props.closeProcessing}/>
        </>
    );
  }
}
// export default Object.assign(UserDevicePage, {ENDPOINT : "/userDevices"})
const ENDPOINT = "/userDevices"
const TITLE = label.UserDevices
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(UserDevicePage, PAGE)


